import { render, staticRenderFns } from "./SelectDepartments.vue?vue&type=template&id=46c177c2&"
import script from "./SelectDepartments.vue?vue&type=script&lang=js&"
export * from "./SelectDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports